import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.13989 8.00023L5.71321 12.5735L14.8599 3.42692", stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
